export const translations = {
  fr: {
    common: {
      appName: "MILKADO",
      enterCode: "Entrer un code",
      hostLogin: "Espace organisateur",
      back: "Retour",
      next: "Continuer",
      cancel: "Annuler",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      loading: "Chargement…",
      logout: "Déconnexion",
      home: "Accueil",
      language: "Langue",
      currency: "USD",
      anonymous: "Anonyme",
      optional: "optionnel",
      required: "requis",
      yes: "Oui",
      no: "Non",
      close: "Fermer",
      copy: "Copier",
      copied: "Copié !",
    },
    landing: {
      heroTitle: "Vos cadeaux",
      heroAccent: "ne sont plus des fardeaux.",
      heroSub: "MILKADO orchestre la wish list, la cagnotte de groupe et la livraison de tous les cadeaux le jour J. Conçu pour tous les hôtes qui voient grand.",
      ctaGuest: "Commencer",
      ctaHost: "Espace organisateur",
      featuresTitle: "Une expérience pensée pour vos plus belles fêtes",
      f1Title: "Paiement sécurisé",
      f1Desc: "Payez par M-Pesa, Orange Money, Airtel Money ou par carte Visa.",
      f2Title: "Code à 6 caractères",
      f2Desc: "Vos invités accèdent à la wish list en une saisie. Sans création de compte.",
      f3Title: "Cadeau en groupe",
      f3Desc: "Créez une cagnotte pour offrir un cadeau collectif.",
      f4Title: "Livraison à 2 vitesses",
      f4Desc: "MILKADO apporte les cadeaux à l'événement pour la remise et les livre au domicile des hôtes après l'événement.",
      howItWorks: "Comment ça marche",
      step1: "Créez votre événement et votre wish list",
      step2: "Partagez un code unique de 6 caractères à vos invités",
      step3: "Vos invités achètent ou cotisent en quelques secondes",
      step4: "Nous livrons tous les cadeaux chez vous après le jour J",
    },
    code: {
      title: "Entrez le code de l'événement",
      sub: "Code à 6 caractères remis par les hôtes",
      submit: "C'est parti !",
      error: "Aucun événement trouvé pour ce code.",
      placeholder: "ABC123",
      noCode: "Vous n'avez pas encore de code événement ?",
      requestCode: "Demander un code",
      requestMessage: "Bonjour Milkado, je souhaite créer un événement et obtenir un code. Pouvez-vous m'accompagner ?",
    },
    event: {
      hostedBy: "Organisé par",
      whenWhere: "Date & lieu",
      gifts: "Wish list",
      noGifts: "La wish list est en cours de préparation. Revenez bientôt.",
      collected: "collecté",
      contributors: "contributeur(s)",
      remaining: "restant(s)",
      ofTotal: "sur",
      offered: "Cadeau déjà offert",
      seeGift: "Voir le cadeau",
      cagnotteOpen: "Cagnotte ouverte",
      fullPurchase: "Achat complet possible",
      address: "Adresse",
      time: "Heure",
      countdown: "Compte à rebours",
      days: "Jours",
      hours: "Heures",
      minutes: "Minutes",
      seconds: "Secondes",
      eventStarted: "L'événement a commencé !",
      actionsTitle: "Comment souhaitez-vous offrir ?",
      frozenTitle: "Achats clôturés",
      frozenBody: "Les achats en ligne sont fermés (gel automatique 48h avant l'événement). Les cadeaux spéciaux restent disponibles jusqu'à J+1.",
      frozenCtaCall: "Appeler Milkado",
      frozenCtaWhatsapp: "Écrire sur WhatsApp",
      frozenWhatsappMsg: "Bonjour Milkado, je souhaite offrir un cadeau de dernière minute pour l'événement {code} ({title}). Pouvez-vous m'aider ?",
      statusUpcoming: "À venir",
      statusLive: "Aujourd'hui",
      statusCompleted: "Terminé",
      statusArchived: "Archivé",
      statusCancelled: "Annulé",
    },
    actions: {
      individual: { title: "Offrir un cadeau individuel", desc: "Choisissez parmi notre boutique" },
      collective: { title: "Cadeau collectif", desc: "Cotisez à plusieurs sur un cadeau" },
      custom: { title: "Cadeau personnalisé", desc: "Une idée originale qui marquera" },
      offered: { title: "Cadeaux offerts", desc: "Voir ce qui a déjà été donné" },
      wishlist: { title: "Wish list", desc: "Liste des cadeaux souhaités par les hôtes" },
      special: { title: "Cadeau spécial", desc: "Expériences & options haut de gamme" },
    },
    shop: {
      title: "Boutique Milkado",
      sub: "Choisissez un cadeau et offrez-le directement.",
      allCategories: "Toutes les catégories",
      noProducts: "Aucun produit dans cette catégorie pour le moment.",
      orderNow: "Commander directement",
      contribute: "Cotiser à la cagnotte",
      supplier: "Fournisseur",
      categories: {
        cuisine: "Cuisine",
        salon: "Salon",
        salle_de_bain: "Salle de bain",
        chambre: "Chambre",
        jardin: "Jardin",
        layette: "Layette",
        electromenager: "Électroménager",
        deco: "Décoration",
      },
    },
    product: {
      pickOption: "Comment souhaitez-vous offrir ?",
      buyFull: "Offrir en entier",
      buyFullSub: "Vous payez la totalité du cadeau",
      joinPot: "Rejoindre la cagnotte",
      joinPotSub: "Saisissez le code groupe pour participer",
      yourShare: "Votre part",
      participantsProgress: "participant(s) ont déjà cotisé",
      groupCode: "Code du groupe",
      groupCodeError: "Code groupe introuvable ou expiré.",
      groupCagnotteFor: "Cagnotte pour",
      offeredAlreadyBy: "Déjà offert par",
      person: "personne",
      persons: "personnes",
      stillOfferable: "Vous pouvez l'offrir à nouveau si vous le souhaitez.",
      uniqueLocked: "Ce cadeau est unique. Il a déjà été offert et n'est plus disponible.",
      amount: "Montant ($)",
      yourName: "Votre nom",
      yourPhone: "Téléphone (optionnel)",
      yourEmail: "Email (optionnel)",
      message: "Message pour les hôtes (optionnel)",
      anonymous: "Rester anonyme pour les hôtes",
      paymentMethod: "Mode de paiement",
      payNow: "Payer maintenant",
      thankYouTitle: "Merci infiniment !",
      thankYouSub: "Votre cadeau est confirmé. Les hôtes vous remercieront le jour J.",
      transactionRef: "Référence",
      backToShop: "Retour à la boutique",
      backToEvent: "Retour à l'événement",
      priceFor: "Prix du cadeau",
      mustEnterName: "Veuillez renseigner votre nom.",
      mustEnterCode: "Veuillez saisir le code groupe.",
      supplier: "Fournisseur",
      description: "Description",
    },
    collective: {
      title: "Créer un cadeau collectif",
      sub: "Réunissez votre groupe pour offrir un beau cadeau ensemble.",
      groupName: "Nom du groupe",
      groupNamePh: "Ex. : Les cousines de la mariée",
      creatorName: "Votre nom (créateur)",
      creatorPhone: "Téléphone du représentant",
      creatorPhonePh: "+243 9xx xxx xxx",
      participantsCount: "Nombre de participants",
      next: "Choisir le cadeau",
      successTitle: "Réservation confirmée !",
      successSub: "Votre code de réservation est valable 7 jours.",
      yourCode: "Votre code",
      expiresOn: "Expire le",
      smsNote: "Un SMS de confirmation vient d'être envoyé au numéro renseigné. Conservez ce code précieusement.",
      smsMockedNote: "(Démo : SMS simulé — le code s'affiche ici en attendant l'intégration Twilio.)",
      shareWhatsapp: "Partager via WhatsApp",
      shareMessage: "🎁 Bonjour ! J'ai créé une cagnotte MILKADO pour offrir un cadeau ensemble.\n\nGroupe : {group}\nCadeau : {product}\nCode groupe : {code}\nValide jusqu'au : {expires}\n\nRejoins la cagnotte sur Milkado avec ce code 👉",
      pickProduct: "Choisissez le cadeau du groupe",
      reserveBtn: "Réserver ce cadeau",
      reservedLabel: "Réservé",
      formError: "Veuillez remplir tous les champs.",
      participantsMin: "Minimum 2 participants pour un cadeau collectif.",
    },
    collectiveChoice: {
      title: "Cadeaux collectifs",
      sub: "Cotisez à plusieurs sur un même cadeau, ou rejoignez une cagnotte existante.",
      createTitle: "Créer un groupe",
      createDesc: "Lancez une nouvelle cagnotte pour offrir un cadeau ensemble.",
      joinTitle: "Participer à une cagnotte",
      joinDesc: "Vous avez reçu un code de groupe ? Rejoignez la cagnotte ici.",
      joinDrawerTitle: "Rejoindre une cagnotte",
      joinDrawerSub: "Saisissez le code de groupe à 4 caractères reçu par WhatsApp ou SMS.",
      joinCta: "Continuer",
      joinError: "Code groupe introuvable ou expiré.",
      joinCodeLabel: "Code du groupe",
    },
    lastMinute: {
      pageTitle: "Cadeau de dernière minute",
      greeting: "Bonjour {name}",
      sub: "Ce cadeau vous est réservé par Milkado.",
      readyTitle: "Votre cadeau est prêt",
      readySub: "Confirmez votre achat — Milkado gère l'achat, le stockage et la livraison le jour J.",
      buyNow: "Offrir ce cadeau",
      payIn: "Payer",
      payLater: "Plus tard",
      paySuccess: "Merci !",
      paySuccessSub: "Votre cadeau de dernière minute est confirmé. Milkado prend le relais.",
      alreadyPurchased: "Ce cadeau a déjà été acheté.",
      countdownPrefix: "Vous avez encore",
      countdownSuffix: "pour confirmer ce cadeau",
      expiredTitle: "Lien expiré",
      expiredBody: "La fenêtre pour confirmer ce cadeau est dépassée. Contactez Milkado pour vous proposer une alternative.",
    },
    settings: {
      pageTitle: "Paramètres Milkado",
      pageSub: "Configuration globale des frais de service. Les modifications s'appliquent immédiatement aux nouveaux achats (les cagnottes en cours et cadeaux déjà offerts ne sont pas impactés).",
      currency: "Devise",
      currencyHelp: "Devise affichée à l'invité sur l'ensemble de l'application.",
      subscriptionFee: "Frais de souscription",
      subscriptionFeeHelp: "Montant fixe que l'hôte verse à Milkado pour activer un nouvel événement.",
      serviceFeeNormal: "Frais de service — cadeaux normaux",
      serviceFeeNormalHelp: "Marge Milkado appliquée sur le prix d'achat fournisseur des cadeaux du catalogue standard.",
      serviceFeeLastMinute: "Frais de service — cadeaux de dernière minute",
      serviceFeeLastMinuteHelp: "Marge premium appliquée sur les cadeaux ajoutés pendant la fenêtre J-48h → J-6h.",
      commissionSpecial: "Commission — cadeaux spéciaux",
      commissionSpecialHelp: "Pourcentage prélevé sur les cadeaux marqués comme spéciaux (achetables jusqu'à J+1).",
      homeDeliveryFee: "Frais de livraison à domicile",
      homeDeliveryFeeHelp: "Forfait facturé pour la livraison des cadeaux au domicile de l'hôte après l'événement.",
      tva: "TVA",
      tvaHelp: "Taxe appliquée sur les frais de service et la livraison à domicile uniquement (pas sur le prix fournisseur).",
      previewTitle: "Aperçu — prix invité",
      previewSub: "Simulation pour un cadeau dont le prix fournisseur est de $100.",
      previewNormal: "Normal",
      previewLastMinute: "Dernière minute",
      previewSpecial: "Spécial",
      save: "Enregistrer",
      saved: "Paramètres enregistrés",
    },
    common2: { allInclusive: "Toutes charges incluses" },
    custom: {
      title: "Cadeau personnalisé",
      sub: "Surprenez les hôtes avec un cadeau hors du commun.",
      intro: "Vous voulez offrir quelque chose qui sort de la liste classique ? Le cadeau personnalisé Milkado, c'est l'occasion d'imaginer un présent qui ressemble vraiment aux mariés ou à l'événement.",
      examplesTitle: "Quelques idées qui marquent",
      e1Title: "Inviter une star à la fête",
      e1Desc: "Faites venir un artiste, un chanteur ou un humoriste pour une performance surprise pendant la soirée.",
      e2Title: "Offrir un show ou une performance",
      e2Desc: "Danseurs, acrobates, percussionnistes, magiciens — créez un moment inoubliable.",
      e3Title: "Payer la salle de réception",
      e3Desc: "Prenez en charge tout ou partie de la location de la salle, un cadeau immense pour les mariés.",
      e4Title: "Offrir l'open bar",
      e4Desc: "Champagne, vins, spiritueux : régalez tous les invités pendant la soirée.",
      e5Title: "Voyage de noces",
      e5Desc: "Contribuez à la lune de miel : billets d'avion, hôtel, excursions.",
      e6Title: "Idée sur-mesure",
      e6Desc: "Vous avez une autre idée folle ? Contactez Milkado, nous organisons tout pour vous.",
      ctaTitle: "Une idée précise en tête ?",
      ctaSub: "Notre équipe vous aide à organiser ce cadeau sur-mesure de A à Z.",
      ctaBtn: "Lancez-vous",
      formTitle: "Parlez-nous de votre idée",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Téléphone",
      wish: "Que souhaitez-vous offrir ?",
      submit: "Envoyer ma demande",
      successTitle: "Demande envoyée !",
      successSub: "Notre équipe vous contactera très vite pour organiser ce beau cadeau.",
      formError: "Veuillez remplir tous les champs.",
    },
    special: {
      title: "Cadeaux spéciaux",
      sub: "Des expériences haut de gamme et options exclusives sélectionnées par Milkado.",
      noProducts: "Aucun cadeau spécial disponible pour le moment.",
    },
    offered: {
      title: "Cadeaux déjà offerts",
      sub: "L'aperçu des cadeaux donnés et réservés pour cet événement.",
      noProducts: "Aucun cadeau encore offert ou réservé.",
      badgeOffered: "Offert",
      badgeReserved: "Réservé",
      reservedOn: "Réservé le",
      expiresOn: "Expire le",
      at: "à 23h59",
    },
    wishlistPage: {
      title: "Wish list des hôtes",
      sub: "Les souhaits sélectionnés spécialement pour cet événement.",
      noItems: "La wish list est en cours de préparation.",
      badgeOpen: "Ouvert",
      badgeReserved: "Réservé",
      badgeOffered: "Offert",
    },
    badges: {
      ouvert: "Ouvert",
      reserve: "Réservé",
      offert: "Offert",
    },
    pay: {
      mpesa: "M-Pesa (Vodacom)",
      orange: "Orange Money",
      airtel: "Airtel Money",
      illicocash: "Illico Cash (Equity BCDC)",
      card: "Carte bancaire",
      cash: "Espèce (bureau ou dépôt bancaire)",
      cashShort: "Espèce",
      cashDesc: "Payez au bureau Milkado ou par dépôt bancaire — confirmation manuelle sous {hours}h.",
      cashIndividualOnly: "Disponible uniquement pour les achats individuels.",
      sandboxNote: "Paiement simulé pour la démo. Aucun montant ne sera prélevé.",
      cashConfirmTitle: "Code de paiement généré",
      cashConfirmSub: "Conservez ce code et présentez-le pour valider votre paiement.",
      cashCodeLabel: "Code de paiement",
      cashReferenceLabel: "Référence à mentionner",
      cashReferenceValue: "Cadeau {code}",
      cashWindowNote: "Vous avez {hours}h pour effectuer le paiement, sinon la réservation est annulée automatiquement.",
      cashOptionA: "Option A — Au bureau Milkado",
      cashOptionB: "Option B — Dépôt bancaire",
      cashOfficeFallback: "Adresse du bureau à communiquer prochainement — contactez le support.",
      cashBankFallback: "Coordonnées bancaires à communiquer prochainement — contactez le support.",
      cashWaitingValidation: "En attente de validation par l'équipe Finances Milkado.",
    },
    admin: {
      login: "Connexion organisateur",
      email: "Email",
      password: "Mot de passe",
      signIn: "Se connecter",
      dashboard: "Tableau de bord",
      myEvents: "Mes événements",
      newEvent: "Nouvel événement",
      noEvents: "Aucun événement encore. Créez votre premier événement.",
      code: "Code",
      gifts: "cadeau(x)",
      collected: "collecté",
      catalog: "Catalogue produits",
      customRequests: "Demandes personnalisées",
      settings: "Paramètres",
      backToDashboard: "Tableau de bord",
      eventForm: {
        title: "Titre de l'événement",
        titlePlaceholder: "Mariage de Joëlle & Patrick",
        hostNames: "Noms des hôtes",
        hostNamesPlaceholder: "Joëlle & Patrick",
        type: "Type d'événement",
        types: { mariage: "Mariage", collation: "Collation", anniversaire: "Anniversaire", autre: "Autre" },
        date: "Date",
        time: "Heure",
        venue: "Salle / Lieu",
        venuePlaceholder: "Pullman Premium, Salle Bonobo",
        address: "Adresse complète",
        description: "Description (optionnel)",
        coverImage: "URL image de couverture (optionnel)",
        homeDelivery: "Livraison à domicile des cadeaux après l'événement",
        subscriptionTitle: "Frais de souscription Milkado",
        subscriptionSub: "Frais d'inscription à régler par l'hôte pour valider l'événement.",
        subscriptionAmount: "Montant",
        subscriptionMethod: "Mode de paiement encaissé",
        create: "Créer l'événement",
        update: "Enregistrer les modifications",
      },
      wishlist: "Wish list de l'événement",
      pickFromCatalog: "Ajouter depuis le catalogue",
      pickerTitle: "Sélectionnez les produits de la wish list",
      pickerDone: "Terminé",
      contributions: "Contributions reçues",
      offeredGifts: "Cadeaux offerts",
      noContribs: "Aucune contribution encore.",
      reservations: "Réservations en cours",
      noReservations: "Aucune réservation en cours.",
      shareCode: "Partagez ce code à vos invités",
      deleteConfirm: "Confirmer la suppression ?",
      cancelEvent: "Annuler l'événement",
      cancelEventConfirm: "Annuler définitivement cet événement ?\n\nL'événement passera en statut « Annulé » et ne sera plus modifiable. Toutes les contributions déjà encaissées resteront enregistrées (traçabilité comptable). Cette action est réservée aux administrateurs.",
      cancelledBanner: "Événement annulé — données en lecture seule.",
      cancelledEvents: "Événements annulés",
      opsTitle: "Opérations logistiques",
      opsDownloadChecklist: "Checklist agents (PDF)",
      opsDownloadDelivery: "Bon de livraison domicile (PDF)",
      pastEvents: "Événements passés",
      upcomingEvents: "Événements à venir",
      adminLockedNotice: "Modification de la wish list bloquée (moins de 6h avant l'événement).",
      lastMinute: {
        sectionTitle: "Cadeaux de dernière minute",
        sectionSub: "Cadeaux invisibles sur la wish list publique, accessibles uniquement via lien privé envoyé au demandeur. Le lien expire 6h avant l'événement.",
        ctaOpen: "Ajouter un cadeau de dernière minute",
        ctaClosed: "Dernière minute (fenêtre J-48h → J-6h)",
        empty: "Aucun cadeau de dernière minute pour l'instant.",
        formTitle: "Nouveau cadeau de dernière minute",
        formSub: "Sélectionnez un produit, indiquez le demandeur — un lien privé est généré pour envoi WhatsApp.",
        requesterName: "Nom du demandeur",
        requesterPhone: "WhatsApp du demandeur (+243…)",
        pickProduct: "Choisir un produit du catalogue",
        successTitle: "Lien généré",
        successSub: "Partagez ce lien avec le demandeur via WhatsApp. Le cadeau est invisible sur la wish list publique.",
        deepLinkLabel: "Lien à envoyer",
        expiresLabel: "Ce lien expire le",
        sendWhatsapp: "Envoyer via WhatsApp",
        copyLink: "Copier le lien",
        copied: "Copié !",
        statusPending: "En attente",
        statusPurchased: "Acheté",
        statusExpired: "Expiré",
        whatsappTemplate:
          "Bonjour {requester}, votre cadeau \"{product}\" pour l'événement \"{event}\" est prêt sur Milkado. Confirmez ici : {link}",
        confirmDelete: "Retirer ce cadeau de dernière minute ?",
      },
      catalogPage: {
        title: "Catalogue produits",
        sub: "Catalogue global Milkado. Disponible pour la wish list des événements et pour la boutique.",
        newProduct: "Nouveau produit",
        editProduct: "Modifier le produit",
        noProducts: "Aucun produit dans le catalogue.",
        specialOnly: "Spéciaux uniquement",
        category: "Catégorie",
        allCategories: "Toutes",
        productForm: {
          create: "Créer le produit",
          update: "Enregistrer",
          name: "Nom du produit",
          description: "Description",
          price: "Prix ($)",
          category: "Catégorie",
          imageUrl: "Image principale",
          additionalImages: "URLs images supplémentaires (une par ligne)",
          supplierName: "Nom du fournisseur",
          supplierContact: "Contact fournisseur (téléphone / email)",
          isSpecial: "Cadeau spécial (Expériences haut de gamme)",
          isUnique: "Cadeau unique (ne peut être offert qu'une fois)",
          stock: "Stock disponible",
        },
      },
    },
  },
  en: {
    common: {
      appName: "MILKADO",
      enterCode: "Enter a code",
      hostLogin: "Host area",
      back: "Back",
      next: "Continue",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      loading: "Loading…",
      logout: "Sign out",
      home: "Home",
      language: "Language",
      currency: "USD",
      anonymous: "Anonymous",
      optional: "optional",
      required: "required",
      yes: "Yes",
      no: "No",
      close: "Close",
      copy: "Copy",
      copied: "Copied!",
    },
    landing: {
      heroTitle: "Your event gifts,",
      heroAccent: "stress-free.",
      heroSub: "MILKADO handles the wish list, group pots and delivery of all gifts on the big day. Built for hosts who think big.",
      ctaGuest: "Get started",
      ctaHost: "Host area",
      featuresTitle: "Crafted for your most beautiful events",
      f1Title: "Secure payment",
      f1Desc: "Pay with M-Pesa, Orange Money, Airtel Money or Visa card.",
      f2Title: "6-character code",
      f2Desc: "Guests reach the wish list with one tap. No account needed.",
      f3Title: "Group gift",
      f3Desc: "Start a group pot to offer a collective gift.",
      f4Title: "Two-speed delivery",
      f4Desc: "MILKADO brings the gifts to the venue for the unveiling, then delivers them to the hosts' home after the event.",
      howItWorks: "How it works",
      step1: "Create your event and wish list",
      step2: "Share a unique 6-character code with your guests",
      step3: "Guests buy or contribute in seconds",
      step4: "We deliver every gift to your home after the event",
    },
    code: {
      title: "Enter the event code",
      sub: "6-character code provided by the hosts",
      submit: "Let's go!",
      error: "No event found for this code.",
      placeholder: "ABC123",
      noCode: "Don't have an event code yet?",
      requestCode: "Request a code",
      requestMessage: "Hello Milkado, I'd like to create an event and get a code. Can you guide me?",
    },
    event: {
      hostedBy: "Hosted by",
      whenWhere: "When & where",
      gifts: "Wish list",
      noGifts: "The wish list is being prepared. Check back soon.",
      collected: "collected",
      contributors: "contributor(s)",
      remaining: "remaining",
      ofTotal: "of",
      offered: "Already gifted",
      seeGift: "See gift",
      cagnotteOpen: "Pot open",
      fullPurchase: "Full purchase available",
      address: "Address",
      time: "Time",
      countdown: "Countdown",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      eventStarted: "The event has started!",
      actionsTitle: "How would you like to gift?",
      frozenTitle: "Purchases closed",
      frozenBody: "Online purchases are closed (automatic freeze 48h before the event). Special gifts remain available until D+1.",
      frozenCtaCall: "Call Milkado",
      frozenCtaWhatsapp: "Message on WhatsApp",
      frozenWhatsappMsg: "Hi Milkado, I'd like to offer a last-minute gift for event {code} ({title}). Can you help me?",
      statusUpcoming: "Upcoming",
      statusLive: "Today",
      statusCompleted: "Completed",
      statusArchived: "Archived",
      statusCancelled: "Cancelled",
    },
    actions: {
      individual: { title: "Offer an individual gift", desc: "Pick from our shop" },
      collective: { title: "Group gift", desc: "Chip in together on one gift" },
      custom: { title: "Custom gift", desc: "An original idea that will stand out" },
      offered: { title: "Already gifted", desc: "See what has been given" },
      wishlist: { title: "Wish list", desc: "List of gifts wished by the hosts" },
      special: { title: "Special gift", desc: "Premium experiences & options" },
    },
    shop: {
      title: "Milkado shop",
      sub: "Pick a gift and offer it directly.",
      allCategories: "All categories",
      noProducts: "No products in this category yet.",
      orderNow: "Order now",
      contribute: "Contribute to pot",
      supplier: "Supplier",
      categories: {
        cuisine: "Kitchen",
        salon: "Living room",
        salle_de_bain: "Bathroom",
        chambre: "Bedroom",
        jardin: "Garden",
        layette: "Baby",
        electromenager: "Appliances",
        deco: "Decor",
      },
    },
    product: {
      pickOption: "How would you like to gift?",
      buyFull: "Offer in full",
      buyFullSub: "Pay the full price of the gift",
      joinPot: "Join the group pot",
      joinPotSub: "Enter the group code to participate",
      yourShare: "Your share",
      participantsProgress: "participant(s) have already paid",
      groupCode: "Group code",
      groupCodeError: "Group code not found or expired.",
      groupCagnotteFor: "Group pot for",
      offeredAlreadyBy: "Already offered by",
      person: "person",
      persons: "people",
      stillOfferable: "You can still offer it again if you'd like.",
      uniqueLocked: "This gift is unique. It has already been offered and is no longer available.",
      amount: "Amount ($)",
      yourName: "Your name",
      yourPhone: "Phone (optional)",
      yourEmail: "Email (optional)",
      message: "Message to the hosts (optional)",
      anonymous: "Stay anonymous to the hosts",
      paymentMethod: "Payment method",
      payNow: "Pay now",
      thankYouTitle: "Thank you so much!",
      thankYouSub: "Your gift is confirmed. The hosts will thank you on the day.",
      transactionRef: "Reference",
      backToShop: "Back to shop",
      backToEvent: "Back to event",
      priceFor: "Gift price",
      mustEnterName: "Please enter your name.",
      mustEnterCode: "Please enter the group code.",
      supplier: "Supplier",
      description: "Description",
    },
    collective: {
      title: "Create a group gift",
      sub: "Gather your group to offer a beautiful gift together.",
      groupName: "Group name",
      groupNamePh: "E.g. The bride's cousins",
      creatorName: "Your name (creator)",
      creatorPhone: "Representative phone",
      creatorPhonePh: "+243 9xx xxx xxx",
      participantsCount: "Number of participants",
      next: "Pick the gift",
      successTitle: "Reservation confirmed!",
      successSub: "Your reservation code is valid for 7 days.",
      yourCode: "Your code",
      expiresOn: "Expires on",
      smsNote: "A confirmation SMS has been sent to the phone provided. Keep this code safe.",
      smsMockedNote: "(Demo: simulated SMS — the code is shown here pending Twilio integration.)",
      shareWhatsapp: "Share via WhatsApp",
      shareMessage: "🎁 Hi! I've started a MILKADO group pot to offer a gift together.\n\nGroup: {group}\nGift: {product}\nGroup code: {code}\nValid until: {expires}\n\nJoin the pot on Milkado with this code 👉",
      pickProduct: "Pick the group's gift",
      reserveBtn: "Reserve this gift",
      reservedLabel: "Reserved",
      formError: "Please fill in all fields.",
      participantsMin: "Minimum 2 participants for a group gift.",
    },
    collectiveChoice: {
      title: "Group gifts",
      sub: "Chip in together on a single gift, or join an existing pot.",
      createTitle: "Create a group",
      createDesc: "Start a new group pot to offer a gift together.",
      joinTitle: "Join an existing pot",
      joinDesc: "Got a group code? Join the pot right here.",
      joinDrawerTitle: "Join a group pot",
      joinDrawerSub: "Enter the 4-character group code received by WhatsApp or SMS.",
      joinCta: "Continue",
      joinError: "Group code not found or expired.",
      joinCodeLabel: "Group code",
    },
    lastMinute: {
      pageTitle: "Last-minute gift",
      greeting: "Hi {name}",
      sub: "This gift is reserved for you by Milkado.",
      readyTitle: "Your gift is ready",
      readySub: "Confirm your purchase — Milkado handles buying, storage and delivery on the day.",
      buyNow: "Offer this gift",
      payIn: "Pay",
      payLater: "Later",
      paySuccess: "Thank you!",
      paySuccessSub: "Your last-minute gift is confirmed. Milkado takes it from here.",
      alreadyPurchased: "This gift has already been purchased.",
      countdownPrefix: "You still have",
      countdownSuffix: "to confirm this gift",
      expiredTitle: "Link expired",
      expiredBody: "The confirmation window for this gift has passed. Please contact Milkado for an alternative.",
    },
    settings: {
      pageTitle: "Milkado settings",
      pageSub: "Global configuration of service fees. Changes apply immediately to new purchases (active group pots and already-offered gifts are not affected).",
      currency: "Currency",
      currencyHelp: "Currency displayed to guests across the app.",
      subscriptionFee: "Subscription fee",
      subscriptionFeeHelp: "Fixed amount paid by the host to activate a new event.",
      serviceFeeNormal: "Service fee — standard gifts",
      serviceFeeNormalHelp: "Milkado margin applied on top of the supplier cost for catalog gifts.",
      serviceFeeLastMinute: "Service fee — last-minute gifts",
      serviceFeeLastMinuteHelp: "Premium margin applied to gifts added during the D-48h → D-6h window.",
      commissionSpecial: "Commission — special gifts",
      commissionSpecialHelp: "Percentage taken on gifts flagged as special (purchasable until D+1).",
      homeDeliveryFee: "Home delivery fee",
      homeDeliveryFeeHelp: "Flat fee charged for delivering all gifts to the host's home after the event.",
      tva: "VAT",
      tvaHelp: "Tax applied on service fees and home delivery only (not on the supplier cost).",
      previewTitle: "Preview — guest price",
      previewSub: "Simulation for a gift with a $100 supplier cost.",
      previewNormal: "Standard",
      previewLastMinute: "Last-minute",
      previewSpecial: "Special",
      save: "Save",
      saved: "Settings saved",
    },
    common2: { allInclusive: "All charges included" },
    custom: {
      title: "Custom gift",
      sub: "Surprise the hosts with an out-of-the-ordinary gift.",
      intro: "Want to offer something beyond the classic list? Milkado's custom gift is your chance to design a present that truly matches the couple or the event.",
      examplesTitle: "A few standout ideas",
      e1Title: "Invite a star to the party",
      e1Desc: "Bring in an artist, singer or comedian for a surprise performance during the evening.",
      e2Title: "Offer a show or performance",
      e2Desc: "Dancers, acrobats, drummers, magicians — create an unforgettable moment.",
      e3Title: "Pay for the venue",
      e3Desc: "Cover all or part of the hall rental — a huge gift for the couple.",
      e4Title: "Offer the open bar",
      e4Desc: "Champagne, wines, spirits — treat every guest throughout the evening.",
      e5Title: "Honeymoon",
      e5Desc: "Contribute to the honeymoon: flights, hotel, excursions.",
      e6Title: "Tailor-made idea",
      e6Desc: "Have another bold idea? Contact Milkado, we'll arrange everything.",
      ctaTitle: "A specific idea in mind?",
      ctaSub: "Our team helps you organise that custom gift end-to-end.",
      ctaBtn: "Let's do it",
      formTitle: "Tell us about your idea",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      wish: "What would you like to offer?",
      submit: "Send my request",
      successTitle: "Request sent!",
      successSub: "Our team will reach out shortly to organise this beautiful gift.",
      formError: "Please fill in all fields.",
    },
    special: {
      title: "Special gifts",
      sub: "Premium experiences and exclusive options curated by Milkado.",
      noProducts: "No special gift available right now.",
    },
    offered: {
      title: "Already gifted",
      sub: "Overview of gifts donated and reserved for this event.",
      noProducts: "No gifts offered or reserved yet.",
      badgeOffered: "Gifted",
      badgeReserved: "Reserved",
      reservedOn: "Reserved on",
      expiresOn: "Expires on",
      at: "at 11:59 PM",
    },
    wishlistPage: {
      title: "Hosts' wish list",
      sub: "Wishes specially picked for this event.",
      noItems: "The wish list is being prepared.",
      badgeOpen: "Open",
      badgeReserved: "Reserved",
      badgeOffered: "Gifted",
    },
    badges: {
      ouvert: "Open",
      reserve: "Reserved",
      offert: "Gifted",
    },
    pay: {
      mpesa: "M-Pesa (Vodacom)",
      orange: "Orange Money",
      airtel: "Airtel Money",
      illicocash: "Illico Cash (Equity BCDC)",
      card: "Credit / Debit card",
      cash: "Cash (office or bank deposit)",
      cashShort: "Cash",
      cashDesc: "Pay at the Milkado office or via bank deposit — manual confirmation within {hours}h.",
      cashIndividualOnly: "Only available for individual purchases.",
      sandboxNote: "Simulated payment for the demo. You will not be charged.",
      cashConfirmTitle: "Payment code generated",
      cashConfirmSub: "Keep this code and present it to validate your payment.",
      cashCodeLabel: "Payment code",
      cashReferenceLabel: "Reference to mention",
      cashReferenceValue: "Cadeau {code}",
      cashWindowNote: "You have {hours}h to complete the payment, otherwise the reservation is automatically cancelled.",
      cashOptionA: "Option A — At the Milkado office",
      cashOptionB: "Option B — Bank deposit",
      cashOfficeFallback: "Office address will be communicated soon — please contact support.",
      cashBankFallback: "Bank details will be communicated soon — please contact support.",
      cashWaitingValidation: "Awaiting validation by the Milkado Finance team.",
    },
    admin: {
      login: "Host sign in",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Dashboard",
      myEvents: "My events",
      newEvent: "New event",
      noEvents: "No events yet. Create your first event.",
      code: "Code",
      gifts: "gift(s)",
      collected: "collected",
      catalog: "Product catalog",
      customRequests: "Custom gift requests",
      settings: "Settings",
      backToDashboard: "Dashboard",
      eventForm: {
        title: "Event title",
        titlePlaceholder: "Joëlle & Patrick's wedding",
        hostNames: "Host names",
        hostNamesPlaceholder: "Joëlle & Patrick",
        type: "Event type",
        types: { mariage: "Wedding", collation: "Reception", anniversaire: "Birthday", autre: "Other" },
        date: "Date",
        time: "Time",
        venue: "Venue",
        venuePlaceholder: "Pullman Premium, Bonobo Hall",
        address: "Full address",
        description: "Description (optional)",
        coverImage: "Cover image URL (optional)",
        homeDelivery: "Deliver all gifts to home after the event",
        subscriptionTitle: "Milkado subscription fee",
        subscriptionSub: "Registration fee paid by the host to validate the event.",
        subscriptionAmount: "Amount",
        subscriptionMethod: "Payment method collected",
        create: "Create event",
        update: "Save changes",
      },
      wishlist: "Event wish list",
      pickFromCatalog: "Add from catalog",
      pickerTitle: "Select wish list products",
      pickerDone: "Done",
      contributions: "Received contributions",
      offeredGifts: "Offered gifts",
      noContribs: "No contributions yet.",
      reservations: "Active reservations",
      noReservations: "No active reservations.",
      shareCode: "Share this code with your guests",
      deleteConfirm: "Confirm deletion?",
      cancelEvent: "Cancel event",
      cancelEventConfirm: "Permanently cancel this event?\n\nThe event will switch to \"Cancelled\" status and become read-only. All collected contributions stay recorded (accounting traceability). This action is restricted to administrators.",
      cancelledBanner: "Event cancelled — read-only data.",
      cancelledEvents: "Cancelled events",
      opsTitle: "Field operations",
      opsDownloadChecklist: "Agents checklist (PDF)",
      opsDownloadDelivery: "Home delivery slip (PDF)",
      pastEvents: "Past events",
      upcomingEvents: "Upcoming events",
      adminLockedNotice: "Wish list editing is locked (less than 6h before the event).",
      lastMinute: {
        sectionTitle: "Last-minute gifts",
        sectionSub: "Hidden from the public wish list, accessible only via the private link sent to the requester. The link expires 6h before the event.",
        ctaOpen: "Add a last-minute gift",
        ctaClosed: "Last-minute (window D-48h → D-6h)",
        empty: "No last-minute gifts yet.",
        formTitle: "New last-minute gift",
        formSub: "Pick a product, enter the requester — a private link is generated for WhatsApp delivery.",
        requesterName: "Requester name",
        requesterPhone: "Requester WhatsApp (+243…)",
        pickProduct: "Pick a product from the catalog",
        successTitle: "Link generated",
        successSub: "Share this link with the requester via WhatsApp. The gift is invisible on the public wish list.",
        deepLinkLabel: "Link to send",
        expiresLabel: "This link expires on",
        sendWhatsapp: "Send via WhatsApp",
        copyLink: "Copy link",
        copied: "Copied!",
        statusPending: "Pending",
        statusPurchased: "Purchased",
        statusExpired: "Expired",
        whatsappTemplate:
          "Hi {requester}, your gift \"{product}\" for the event \"{event}\" is ready on Milkado. Confirm here: {link}",
        confirmDelete: "Remove this last-minute gift?",
      },
      catalogPage: {
        title: "Product catalog",
        sub: "Global Milkado catalog. Available for event wish lists and the shop.",
        newProduct: "New product",
        editProduct: "Edit product",
        noProducts: "No product in the catalog.",
        specialOnly: "Special only",
        category: "Category",
        allCategories: "All",
        productForm: {
          create: "Create product",
          update: "Save",
          name: "Product name",
          description: "Description",
          price: "Price ($)",
          category: "Category",
          imageUrl: "Main image",
          additionalImages: "Additional image URLs (one per line)",
          supplierName: "Supplier name",
          supplierContact: "Supplier contact (phone / email)",
          isSpecial: "Special gift (premium experiences)",
          isUnique: "Unique gift (can only be offered once)",
          stock: "Available stock",
        },
      },
    },
  },
};
